import { render } from "./EnterPasswordComponent.vue?vue&type=template&id=c12a1ce8&ts=true"
import script from "./EnterPasswordComponent.vue?vue&type=script&lang=ts"
export * from "./EnterPasswordComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/terrencewong/ispeech/ispeech-web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__